<template>
    <div>
    <v-dialog
        name="example-dialogue"
    />

        <modal 
            v-if="enabled"
            :key="key"
            :resizable="config.resizable"
            :draggable="config.draggable"
            :clickToClose="config.clickToClose"
            :width="config.width"
            :height="config.height"
            @opened="onOpened"
            @before-close="onBeforeClose"
            @closed="onClosed"
            name="bf-card-modal"
            v-bind="config"
            >
            
            <div slot="top-right">
            </div>
            
            <!--takes id or urnSlug slug -->
    
            <form-frame  
                v-if="enabled"
                ref="card-modal"  
                :id="config.idForm"
                :idWndw=config.id
                :urnSlug="config.slug"
                :model="config.model"
                :query="config.query"
                :key="_uid"
                />
                
        </modal>
    </div>
</template>

<script>

    import { EventBus } from 'Js/eventBus';
    import VueJsModal from 'vue-js-modal';
    import FormFrame from '../layouts/form.vue';
    import { actions } from 'Js/actionsProcessor';
    
    Vue.use(VueJsModal, {
        dialog: true,
        dynamic: true,
    });
    
    export default {
        props: [],
        name: 'cardmodal',
    
        components: {
            FormFrame,
            VueJsModal
        },
    
        computed: {
            windows() {
                return this.$store.getters.getModals
            }
        },
    
        watch: {
            windows: function(newVal, oldVal) {
                if (newVal.length == oldVal.length) {
                    return
                }
                // only modal tpyes here, so take first one and open that
                // in future can support multiples
                newVal.length ? this.showCardModal(newVal[0]) : null
            }
        },
    
        methods: {
            showCardModal: function(config) {
                this.key++
                this.config = {}
                this.config = Object.assign({}, this.defaults, config)
                this.enabled = true
                this.$nextTick(() => {
                    this.$modal.show('bf-card-modal')
                })
            },
    
            hideModal: function(config) {
                this.enabled ? this.$modal.hide('bf-card-modal') : actions.process()
            }, 
    
            onOpened: function() {
                actions.process()
            },
    
            onBeforeClose: function(event) {
                this.$store.dispatch('ACTIONS_PAUSE', true);
                typeof this.config.onBeforeClosed === "function" ? this.config.onBeforeClosed(event): null
            },
    
            onClosed: function(event) {
                this.$store.dispatch('ACTIONS_PAUSE', false);
                this.enabled = false
                typeof this.config.onClosed === "function" ? this.config.onClosed(event) : null
                this.$store.dispatch('REMOVE_WINDOW', this.config.id);
                actions.process();
            },
        },
    
        mounted() {
    
            EventBus.$on('showCardModal', config => {
                this.showCardModal(config)
            });
    
            EventBus.$on('hideCardModal', config => {
                this.hideModal(config)
            });
    
        },
    
        errorCaptured(err, vm, info) {
            console.log('HTML rendered an error in CardModal: ', err, info)
            return false // stop propagation
        },
    
        data() {
            return {
                config: {},
                key: 0,
                enabled: false,
                defaults: {
                    name: 'bf-card-modal',
                    delay: 0,
                    transition: "nice-modal-fade",
                    minWidth: 200,
                    minHeight: 200,
                    adaptive: true,
                    name: "modal",
                    resizable: false,
                    clickToClose: true,
                    draggable: false,
                    scrollable: true,
                    height: "auto"
                },
            };
        },
    
    }

</script>

<style scoped>

</style>

